import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const ScrollWrapper = styled.ScrollView`
  flex: 1;
`;

export const Content = styled.View`
  padding: ${RFValue(24)}px;
`;

export const PageTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.bold};
  margin-bottom: ${RFValue(14)}px;
`;

export const PageSubtitle = styled.Text`
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
  margin-top: -${RFValue(8)}px;
  margin-bottom: ${RFValue(8)}px;
`;

export const StatusCard = styled.View`
  border-radius: ${RFValue(16)}px;
  padding: ${RFValue(16)}px;
  border-width: 1px;
  shadow-color: #000;
  shadow-offset: 0px 2px;
  shadow-opacity: 0.06;
  shadow-radius: 6px;
  elevation: 2;
`;

export const StatusTopRow = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(12)}px;
`;

export const StatusIconCircle = styled.View`
  width: ${RFValue(42)}px;
  height: ${RFValue(42)}px;
  border-radius: ${RFValue(21)}px;
  align-items: center;
  justify-content: center;
`;

export const StatusTextGroup = styled.View``;

export const StatusLabel = styled.Text`
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const StatusValue = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const StatusSeparator = styled.View`
  height: 1px;
  background-color: ${({theme}) => theme.colors.border};
  margin: ${RFValue(14)}px 0;
`;

export const TotalLabel = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const TotalValue = styled.Text`
  font-size: ${RFValue(24)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.bold};
  margin-top: ${RFValue(2)}px;
`;

export const LiquidationRow = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(4)}px;
  margin-top: ${RFValue(8)}px;
`;

export const LiquidationText = styled.Text`
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const SectionTitle = styled.Text`
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.semibold};
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-top: ${RFValue(20)}px;
  margin-bottom: ${RFValue(8)}px;
`;

interface InfoCardProps {
  accentColor?: string;
}

export const InfoCard = styled.View<InfoCardProps>`
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(16)}px;
  overflow: hidden;
  shadow-color: #000;
  shadow-offset: 0px 2px;
  shadow-opacity: 0.06;
  shadow-radius: 6px;
  elevation: 2;
  border-left-width: ${({accentColor}) => (accentColor ? 3 : 1)}px;
  border-left-color: ${({accentColor, theme}) => accentColor ?? theme.colors.border};
  border-top-width: 1px;
  border-top-color: ${({theme}) => theme.colors.border};
  border-right-width: 1px;
  border-right-color: ${({theme}) => theme.colors.border};
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
`;

export const InfoRow = styled.View`
  padding: ${RFValue(12)}px ${RFValue(16)}px;
`;

export const InfoRowWithIcon = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(10)}px;
  padding: ${RFValue(10)}px ${RFValue(14)}px;
`;

export const InfoIconWrapper = styled.View`
  width: ${RFValue(30)}px;
  height: ${RFValue(30)}px;
  border-radius: ${RFValue(7)}px;
  background-color: ${({theme}) => theme.colors.background_secondary};
  align-items: center;
  justify-content: center;
`;

export const InfoRowContent = styled.View`
  flex: 1;
`;

export const InfoSeparator = styled.View`
  height: 1px;
  background-color: ${({theme}) => theme.colors.border};
`;

export const InfoLabel = styled.Text`
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: ${RFValue(2)}px;
`;

export const InfoValue = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const FinancialRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${RFValue(12)}px ${RFValue(14)}px;
`;

export const FinancialLabel = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const FinancialValue = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const FinancialLabelBold = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const FinancialValueBold = styled.Text`
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.bold};
`;

interface TotalBadgeProps {
  bg: string;
}

export const TotalBadge = styled.View<TotalBadgeProps>`
  padding: ${RFValue(4)}px ${RFValue(12)}px;
  border-radius: ${RFValue(100)}px;
  background-color: ${({bg}) => bg};
`;

export const TotalBadgeText = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const Footer = styled.View`
  padding: 0 ${RFValue(24)}px;
  margin-top: ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.background};
`;

export const VerDebitsRow = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${RFValue(14)}px ${RFValue(16)}px;
`;

export const VerDebitsText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
`;

export const SheetContainer = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  border-top-left-radius: ${RFValue(20)}px;
  border-top-right-radius: ${RFValue(20)}px;
  padding-bottom: ${RFValue(32)}px;
`;

export const SheetHandle = styled.View`
  width: ${RFValue(36)}px;
  height: ${RFValue(4)}px;
  border-radius: ${RFValue(2)}px;
  background-color: ${({theme}) => theme.colors.border};
  align-self: center;
  margin-top: ${RFValue(12)}px;
  margin-bottom: ${RFValue(16)}px;
`;

export const SheetTitle = styled.Text`
  font-size: ${RFValue(13)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(12)}px;
  padding: 0 ${RFValue(16)}px;
`;

export const SheetCard = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(16)}px;
  border: 1px solid ${({theme}) => theme.colors.border};
  overflow: hidden;
  margin: 0 ${RFValue(16)}px ${RFValue(12)}px;
`;
